export default class DeviceList {

	constructor (data) {
		this.data = data

		// Build id index
		this.index = {}
		for (let entry of this.data) {
			this.index[entry.id] = entry
		}

		// Build machine_id index
		this.machine_index = {}
		for (let entry of this.data) {
			this.machine_index[entry.machine_id] = entry
		}
	}

	static async fetch () {

		let data = await Anvil.REST.get('/c_order/terminal/detailed_list')

		return new DeviceList(data.filter(e => e.type == 'android' && e.version == 'haccp'))
	}

	getById (id) {
		return this.index[id]
	}

	getByMachineId (machine_id) {
		return this.machine_index[machine_id]
	}
}
